import variableColors from "../_App.module.scss";

const { darkColor, secondaryColor, pinkColor, tealColor, warningColor, appBackgroundColorWhiteSmoke } = variableColors;

export const speedColorMapMph = new Map<number, string>([
  [44, "#008000"], // Green
  [35, "#ADFF2F"], // Light Green
  [25, "#FFFF00"], // Yellow
  [16, "#FFA500"], // Orange
  [7, "#FF0000"], // Red
  [0, "#8B0000"], // Dark Red
]);

export const speedColorMapKmh = new Map<number, string>([
  [71, "#008000"], // Green
  [56, "#ADFF2F"], // Light Green
  [40, "#FFFF00"], // Yellow
  [26, "#FFA500"], // Orange
  [11, "#FF0000"], // Red
  [0, "#8B0000"], // Dark Red
]);

export const getSpeedColor = (speed: number, units: string): string => {
  const speedColorMap: Map<number, string> = units === "kmh" ? speedColorMapKmh : speedColorMapMph;

  // Find the highest threshold less than or equal to speed
  for (const [threshold, color] of Array.from(speedColorMap.entries()).sort(
    (a: [number, string], b: [number, string]) => b[0] - a[0]
  )) {
    if (speed >= threshold) {
      return color;
    }
  }
  return darkColor; // Default/fallback color, should not happen
};

//* Color status of buses
export const getHeadwayStatusColor = (status: string): string => {
  if (!status) {
    return appBackgroundColorWhiteSmoke;
  }
  switch (status) {
    case "UNAVAILABLE":
      return secondaryColor;
    case "EXPECTED":
      return tealColor;
    case "BUNCHED":
      return pinkColor;
    case "GAPPED":
      return warningColor;
    default:
      return appBackgroundColorWhiteSmoke;
  }
};

//* Headway category buses filter
export const getHeadwayCategoryBuses = (headwayDeviationCategory: string, allWorkingHeadwayBuses: BusInfo[]): BusInfo[] => {
  switch (headwayDeviationCategory) {
    case "UNAVAILABLE":
      return allWorkingHeadwayBuses?.filter((bus: BusInfo) => bus?.headwayDeviationCategory === "UNAVAILABLE");
    case "EXPECTED":
      return allWorkingHeadwayBuses?.filter((bus: BusInfo) => bus?.headwayDeviationCategory === "EXPECTED");
    case "BUNCHED":
      return allWorkingHeadwayBuses?.filter((bus: BusInfo) => bus?.headwayDeviationCategory === "BUNCHED");
    case "GAPPED":
      return allWorkingHeadwayBuses?.filter((bus: BusInfo) => bus?.headwayDeviationCategory === "GAPPED");
    case "workingAllHeadwayBuses":
      return [...allWorkingHeadwayBuses];
    default:
      return allWorkingHeadwayBuses;
  }
};
